exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mdadw {\r\n    margin-top: 13px;\r\n    width: 165px;\r\n    height: 165px;\r\n}\r\n\r\n.required:after {\r\n    content: \" *\";\r\n    color: #d00;\r\n}\r\n\r\n#table-user-connect-line tr.odd {\r\n    background: #f9f9f9;\r\n}\r\n\r\n#table-user-connect-line tr.even {\r\n    background-color: rgb(60, 141, 188);\r\n}\r\n\r\n.cus-pd-50 {\r\n    padding-bottom: 50px !important;\r\n}\r\n\r\n.cus-mr-top50 {\r\n    margin-top: 50px !important;\r\n}\r\n\r\n.cust-mr-l-30 {\r\n    margin-left: 30px !important;\r\n}\r\n\r\n.cust-mr-l-50 {\r\n    margin-left: 50px !important;\r\n}\r\n\r\n.cmd-connect {\r\n    color: greenyellow;\r\n}\r\n\r\n.cmd-default {\r\n    font-weight: bold;\r\n}\r\n\r\n.text-warning-connect {\r\n    color: #F89D2E;\r\n}\r\n\r\ndiv.show-feature {\r\n    cursor: pointer;\r\n    color: #3c8dbc;\r\n}\r\n\r\ndiv.show-feature:hover {\r\n    text-decoration: underline;\r\n    color: #00a7d0;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/user/profile-user/change-profile.component.css
// module id = ../../../../../src/app/_components/user/profile-user/change-profile.component.css
// module chunks = main